import React from "react";

const Footer = () => {
  return (
    <div className="bg-slate-700 text-sm p-4 text-center text-white">
      Copyright © 2025 Ayush Agrawal. All Rights reserved.
    </div>
  );
};

export default Footer;
